import React from "react";
import { getRequest } from "sharedUtils/httpUtils";
import MUIDataTable from "mui-datatables";
import { convertToNumericMonthAndDayAndYearAndTime } from "sharedUtils/timeUtils";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { CheckIconBlack } from "../../icons";
import PenIcon from "components/icons/PenIcon";

const { DateTime } = require("luxon");

class ShareASaleMerchantData extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();

        this.state = {
            merchants: [],
            merchantsLoading: false,
            MerchantsTable: {
                title: "Affiliate merchants",
                options: {
                    selectableRows: "multiple",
                    rowsPerPage: 100,
                    sortOrder: {
                        name: 'merchantName',
                        direction: 'asc'
                    },
                },
                getTheme: () => createTheme({
                    typography: {
                        fontFamily: "'Urbanist', 'sf_pro_displayregular', sans-serif",
                    },
                    overrides: {
                        MUIDataTableBodyRow: {
                            root: {
                                '&:nth-child(odd)': {
                                    backgroundColor: '#F9F9F9'
                                },
                                cursor: 'pointer'
                            }
                        },
                    }
                })
            },
        };
    }

    componentDidMount = () => {
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });
        this.getMerchants();
    };

    getMerchants = async () => {
        let url = `/api/Merchant/GetShareASaleMerchants`;

        this.setState({ merchantsLoading: true });

        try {
            const merchants = await getRequest(url);

            this.setState({
                merchants,
                merchantsLoading: false,
            });
        } catch (error) {
            console.error("Error fetching merchants:", error);
            this.setState({ merchants: [], merchantsLoading: false });
        }
    };

    onTabChange = (tab) => {
        this.setState({ tab });
    }

    render() {
        const columns = [
        {
            name: "merchantId",
            label: "Merchant ID",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    return value ?? "-";
                }
            }
        },
        {
            name: "merchant",
            label: "Merchant",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    return value ?? "-";
                }
            }
        },
        {
            name: "hostname",
            label: "Hostname",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    if (!value) return "-";
                    const index = value.indexOf("?");
                    return index !== -1 ? value.slice(0, index) : value;
                }
            }
        },
        {
            name: "programStatus",
            label: "Program Status",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    return value ?? "-";
                }
            }
        },
        {
            name: "programCategory",
            label: "Program Category",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    return value ?? "-";
                }
            }
        },
        {
            name: "saleCommission",
            label: "Sale Commission",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    return value ? `${value}` : "-";
                }
            }
        },
        {
            name: "leadCommission",
            label: "Lead Commission",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    return value;
                }
            }
        },
        {
            name: "hitCommission",
            label: "Hit Commission",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    return value;
                }
            }
        },
        {
            name: "approved",
            label: "Approved",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    return value === "Yes" ? "✅ Yes" : value === "Pending" ? "⏳ Pending" : value === "Declined" ? "❌ Declined" : value;
                }
            }
        },
        {
            name: "linkUrl",
            label: "Link URL",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    return value ? (
                        <a href={value} target="_blank" rel="noopener noreferrer">
                            {value}
                        </a>
                    ) : "-";
                }
            }
        },
        {
            name: "storeNames",
            label: "Store Names",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    return value ? value.split(",").join(", ") : "-";
                }
            }
        },
        {
            name: "storeWebsites",
            label: "Store Websites",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    if (!value) return "-";
                    const websites = value.split(",").map((url, index) => (
                        <div key={index}>
                            <a href={url.trim()} target="_blank" rel="noopener noreferrer">{url.trim()}</a>
                        </div>
                    ));
                    return websites;
                }
            }
        },
        {
            name: "ruleCommissionDate",
            label: "Rule Commission Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    return value
                        ? new Date(value).toLocaleDateString("en-US")
                        : "-";
                }
            }
        },
        {
            name: "conversionLineDate",
            label: "Conversion Line Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    return value
                        ? new Date(value).toLocaleDateString("en-US")
                        : "-";
                }
            }
        },
        {
            name: "shipsTo",
            label: "Ships To",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    return (
                        <div style={{ width: "500px", wordWrap: "break-word" }}>
                            {value}
                        </div>
                    )
                }
            }
        }
    ];


        return (
            <div>
                <ThemeProvider theme={this.state.MerchantsTable.getTheme()}>
                    <MUIDataTable
                        title={
                            <div style={{ fontFamily: "'Urbanist', sans-serif" }}>
                                <p style={{ fontSize: '22px', marginTop: "20px" }}>{this.props.affiliateProgramManager?.name + " merchants" ?? "No affiliate selected"}</p>
                            </div>
                        }
                        data={this.state.merchants}
                        columns={columns}
                        options={{
                            ...this.state.MerchantsTable.options,
                            textLabels: {
                                body: { noMatch: this.state.merchantsLoading ? "LOADING..." : "No data available" },
                            },
                            selectableRows: "none",
                        }}
                        ref={this.tableRef}
                    />
                </ThemeProvider>
            </div>
        );
    }
}

export default ShareASaleMerchantData;
